import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAccountStatement, getContractData } from 'actions/selfservice';
import { isMobile } from 'utils/helpers';
import Transactions from 'components/Credit24/SelfService/Transactions';
import TransactionsSearchForm from 'components/Credit24/SelfService/Transactions/TransactionsSearchForm';
import TransactionsMobile from 'components/Credit24/SelfService/Transactions/TransactionsMobile';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  getAccountStatement: PropTypes.func,
  getContractData: PropTypes.func,
};

class TransactionsContainer extends Component {
  componentDidMount() {
    const {
      authentication: { contracts = [] },
    } = this.props;

    contracts.forEach((contractId) => {
      this.props.getContractData(contractId);

      if (isMobile) {
        // On mobile, we have no date filter, so get all transactions from arbitrary startDate
        this.props.getAccountStatement(contractId, '2000-01-01');
      } else {
        this.props.getAccountStatement(contractId);
      }
    });
  }

  buildFilterMap(transactions) {
    // Filter wants to know what years and months exist in the data
    const filterMap = [];

    transactions.forEach((transaction) => {
      const transactionDate = moment(transaction.created);
      const transactionMonth = transactionDate.month();
      const transactionYear = transactionDate.year();

      // Check that the current year is not already represented
      if (!filterMap[transactionYear]) {
        // If it's not, create it
        filterMap[transactionYear] = { year: transactionYear, months: [transactionMonth] };
        // Check that the current month is not already represented
      } else if ((filterMap[transactionYear].months.indexOf(transactionMonth) < 0)) {
        // There can only be one curYearObj in the filter list, because we make sure of it
        filterMap[transactionYear].months.push(transactionMonth);
      }
    });

    // Flip the years because we're displaying them in reverse order
    filterMap.reverse();

    return filterMap;
  }

  render() {
    const { authentication, selfservice } = this.props;

    const contractId = authentication.contracts[0];
    const transactionsArray = selfservice.transactions[contractId] || [];

    return (
      <div className="content-block">
        {
          isMobile
            ? (
              <TransactionsMobile
                transactions={transactionsArray}
                filterMap={this.buildFilterMap(transactionsArray)}
              />
            )
            : (
              <>
                <TransactionsSearchForm
                  contractId={contractId}
                  onSubmit={this.props.getAccountStatement}
                />
                <div className="content-block__full-child">
                  <Transactions transactions={transactionsArray} />
                </div>
              </>
            )
        }
      </div>
    );
  }
}

TransactionsContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    selfservice: state.selfservice,
    authentication: state.authentication,
  }),
  { getAccountStatement, getContractData }
)(TransactionsContainer);
